// src/pages/Dashboard.jsx
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FaUsers, FaTicketAlt, FaShoppingBag, FaUserShield } from 'react-icons/fa';
import { API_BASE } from '../utils/helpers';

const STAT_CARDS = [
  { key: 'total_users', label: 'Total Users', icon: FaUsers, tone: 'indigo' },
  { key: 'total_coupons', label: 'Total Coupons', icon: FaTicketAlt, tone: 'emerald' },
  { key: 'total_orders', label: 'Wallet Orders', icon: FaShoppingBag, tone: 'rose' },
  { key: 'total_internal_users', label: 'Internal Users', icon: FaUserShield, tone: 'sky' },
];

const TONES = {
  indigo: 'bg-indigo-50 text-indigo-600',
  emerald: 'bg-emerald-50 text-emerald-600',
  rose: 'bg-rose-50 text-rose-600',
  sky: 'bg-sky-50 text-sky-600',
};

function StatCard({ label, value, icon: Icon, tone, loading }) {
  return (
    <div className="ui-card p-5">
      <div className="flex items-start justify-between">
        <div>
          <p className="text-sm font-medium text-slate-500">{label}</p>
          {loading ? (
            <div className="mt-2 h-8 w-16 animate-pulse rounded bg-slate-100" />
          ) : (
            <p className="mt-1 text-3xl font-semibold tracking-tight text-slate-900">
              {value ?? '—'}
            </p>
          )}
        </div>
        <span className={`flex h-11 w-11 items-center justify-center rounded-xl ${TONES[tone]}`}>
          <Icon className="text-lg" />
        </span>
      </div>
    </div>
  );
}

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get(`${API_BASE}/api/dashboard/stats`);
        setStats(res.data);
      } catch (err) {
        console.error('Failed to fetch dashboard stats', err);
        setError('Failed to load dashboard stats.');
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div>
      <div className="mb-6">
        <h2 className="text-lg font-semibold text-slate-900">Overview</h2>
        <p className="text-sm text-slate-500">Key metrics across the Moona platform.</p>
      </div>

      {error ? (
        <div className="ui-card p-6 text-sm text-rose-600">{error}</div>
      ) : (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
          {STAT_CARDS.map((s) => (
            <StatCard
              key={s.key}
              label={s.label}
              value={stats?.[s.key]}
              icon={s.icon}
              tone={s.tone}
              loading={loading}
            />
          ))}
        </div>
      )}
    </div>
  );
}
